import { gateway } from "../../../../gateway";

export const deleteSupplyProvider = async ({ token, id }) => {
  try {
    const res = await gateway.delete(`/supplies/providers/self/${id}`, {
      headers: {
        Authorization: `${token}`,
      },
    });
    return res.data;
  } catch (error) {
    throw error;
  }
};
